/**
 * LinkButton — the router-coupled half of the button family: a TanStack `<Link>` styled as
 * a `<Button>` (type-safe `to`). `Button`, `ButtonLink` (the plain `<a>`) and
 * `buttonClassName` live in `@argus/ui` (packages/ui/src/button.tsx) and are re-exported
 * here so every existing `../ui/button.tsx` import keeps working.
 */
import { ButtonLink } from '@argus/ui';
import { createLink, type LinkComponent } from '@tanstack/react-router';

export { Button, ButtonLink, buttonClassName } from '@argus/ui';
export type { ButtonProps, ButtonSize, ButtonStyleProps, ButtonVariant } from '@argus/ui';

const CreatedLinkButton = createLink(ButtonLink);

/** A router `<Link>` that looks like a `<Button>`; `to` is type-checked against the route tree. */
export const LinkButton: LinkComponent<typeof ButtonLink> = (props) => (
  <CreatedLinkButton {...props} />
);
